<div class="partners-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="partners-title">
          <span translate>kazakhstan.nav_partners</span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="brand-list">
  <div class="container">
    <div class="row justify-content-center gap-4">
<!--      <div class="col-xl-3 col-lg-6 col-md-6">-->
<!--        <div class="img-body">-->
<!--          <img src="../../assets/img/kazyna.png" alt="">-->
<!--        </div>-->
<!--        <div class="brand-info">-->
<!--          <span>Самұрық-Қазына қоры</span>-->
<!--        </div>-->
<!--      </div>-->
      <div class="col-xl-3 col-lg-6 col-md-6">
        <div class="img-body-no-back d-flex align-items-center px-1">
          <img src="../../assets/img/partners/turism.png" alt="">
        </div>
        <div class="brand-info">
          <span>Туризм және спорт министрлігі</span>
        </div>
      </div>
      <div class="col-xl-3 col-lg-6 col-md-6">
        <div class="sportty-damu img-body-no-back d-flex align-items-center justify-content-center">
          <img src="../../assets/img/partners/sport-qory.png" alt="">
        </div>
        <div class="brand-info">
          <span>Sport Qory</span>
        </div>
      </div>
<!--      <div class="col-xl-3 col-lg-6 col-md-6">-->
<!--        <div class="almaty-akim img-body d-flex align-items-center justify-content-center">-->
<!--          <img src="../../assets/img/partners/akimat.png" alt="">-->
<!--        </div>-->
<!--        <div class="brand-info">-->
<!--          <span>Алматы қаласы әкімдігі</span>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</div>
